export const DEFAULT_PAGE_SIZE_INFINITE_SCROLL = 10;

const PAGE_SIZES = [
  {
    id: '1',
    name: 1,
  },
  {
    id: '5',
    name: 5,
  },
  {
    id: '10',
    name: 10,
  },
  {
    id: '20',
    name: 20,
  },
] as const;

export default PAGE_SIZES;
